export default {
  form: {
    hints: {
      contract: {
        // cable_modem_bin: 'Custom cable modem DOCSIS binary file for this contract.',
        // cable_modem_enabled: 'Works only on Bmu versions greater or equal than 0.7.0.',
        coverage_id: 'Node -> Coverage (D: Distance to node)',
        // dhcp_server: 'Only works for MikroTik',
        ip_address: 'Autocomplete for free ips will start to work after 6 characters',
        massive_update: {
          mikrotik_interface_id: 'Will only appear the LAN interfaces',
          plan_id: 'If plan change, the price and frequency will be auto propagated'
        },
        mikrotik_interface_id:
          'Interface where the contract is physically connected. This option is necessary only for Mikrotik, required for ARP and mac address finder.',
        nap_id: 'NAP -> [Availability] (D: Distance to NAP)',
        ppp_profile: `PPP Profile will be used to create PPPoE Secrets. This option is necessary only for MikroTik. Note: In case doesn't show the option, first import the PPP profile from the server view.`,
        public_address:
          'Address that will be used to perform FULL-NAT with the contract IP. MikroTik: You will only be able to select addresses from interfaces marked as WAN. If you use an address for FULL-NAT, you will not be able to redirect ports or assign it to another contract.'
      },
      invoicing: {
        recurring_item: {
          lapse:
            'Number that indicates how many periods the item will be charged. For instance, on a monthly contract it indicates how many months that item will be charged. If you leave this input blank, the item will be charged indefinitely.'
        }
      },
      employee: {
        zones:
          'The selected zones will only allow to see the clients and everything related with the same zone. If you leave the field empty you will be able to see ALL clients.'
      },
      client: {
        invoicing_client_attributes: {
          vat_condition: "Client's iva condition (Receiver)",
          start_invoicing_day:
            'Changing the invoice day will affect all contracts, and will be effective as of the next invoice period'
        }
      }
    },
    no_matches_found: 'No matches found',
    required: 'Required',
    save_btn: 'Save',
    select_input: 'Choose an option',
    show_less: 'Show less',
    show_more: 'Show more'
  }
};
